module.exports = __webpack_public_path__ + "static/img/c1.690d797.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/center/pit/tremor/c1.jpg
// module id = gi9U
// module chunks = 0